import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-63" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 pt-[0px] py-14 text-center" data-id="element-64" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="32pp7k5pwm171">
          Fiesta Épica<span className="align-super text-xs" data-id="element-66" data-mp="36q92r3qx2uqj">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3ueik9th3kwbv">
          El sistema de organización N°1 para cumpleaños infantiles de Argentina. Porque el
          cumpleaños de tu hijo no debería costarte semanas de estrés y noches sin dormir.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3qdf5796vj4bp">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-69" data-mp="29zgkbzgigqll">
            <MailIcon className="h-4 w-4 text-iris-soft" data-id="element-70" data-mp="2evx98vvjb8zq" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-71" data-mp="3lbdces4h47la">
            <InstagramIcon className="h-4 w-4 text-iris-soft" data-id="element-72" data-mp="3v7zvbbd8ooko" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-iris-soft" data-id="element-73" data-mp="3q8dj9595dedg">
            <GlobeIcon className="h-4 w-4 text-iris-soft" data-id="element-74" data-mp="817d85ghpotj" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-iris-soft" data-id="element-75" data-mp="31uo1e25c5ns">
          “El cumpleaños que tu hijo va a recordar siempre empieza hoy.” 🎂
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="cus3fbbudei6">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="quji7ea6myx8">
            Términos y condiciones
          </a>
          <span data-id="element-78" data-mp="mtrcgv0irc5p">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="mq3gzqbikfoc">
            Política de privacidad
          </a>
          <span data-id="element-80" data-mp="yto9e2nu4fxd">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="yv92dnui3qt4">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="13rpuet4tmpbh">
          © 2026 Fiesta Épica™ — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}